export default __webpack_public_path__ + "static/media/149_batata_kawai0001.6516b7cc.png";